import { render, staticRenderFns } from "./WarehouseAllocationRules.vue?vue&type=template&id=1c79da50"
import script from "./WarehouseAllocationRules.vue?vue&type=script&lang=js"
export * from "./WarehouseAllocationRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports